/**
 * Where the owner panel lives. In development it is the dev server on 5180; in other builds it
 * must be configured (`VITE_UZ_OWNER_URL`), otherwise no link is offered.
 */
export function ownerPanelBase(): string | null {
  const configured = (import.meta.env["VITE_UZ_OWNER_URL"] as string | undefined)?.trim();
  if (configured) return configured.replace(/\/+$/, "");
  return import.meta.env.DEV ? "http://localhost:5180" : null;
}

/** Deep link to the owner panel's Connections page for one company. */
export function ownerConnectionsUrl(
  companyId: string | null,
  base = ownerPanelBase(),
): string | null {
  if (!base) return null;
  const q = new URLSearchParams({ page: "connections" });
  if (companyId) q.set("company", companyId);
  return `${base.replace(/\/+$/, "")}/?${q.toString()}`;
}
